var map = {
	"./de/resetpassword.json": 48862,
	"./en/resetpassword.json": 47727,
	"./es/resetpassword.json": 86775,
	"./fr/resetpassword.json": 99516,
	"./pt/resetpassword.json": 59847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67265;